import { BrandIconListSection as BrandIconListSectionType } from '../../LandingPage.types'
import css from './BrandIconListSection.styles.scss'
import { LinkArrowIcon } from '../../LandingPage.icons'

interface BrandIconListSectionProps {
  section: BrandIconListSectionType
}

const BrandIconListSection = ({
  section: {
    headerText,
    icons,
    callToAction: { text, url },
  },
}: BrandIconListSectionProps) => (
  <div className={css.BrandIconListSection__container}>
    <h2 className={css.BrandIconListSection__heading}>{headerText}</h2>
    <div className={css.BrandIconListSection__iconContainer}>
      {icons.map(({ imageComponent, url, id }) => (
        <a href={url} key={id} rel="noreferrer" target="_blank">
          {imageComponent}
        </a>
      ))}
    </div>
    <a
      className={css.BrandIconListSection__link}
      href={url}
      rel="noreferrer"
      target="_blank"
    >
      <span>{text}</span>
      <LinkArrowIcon className={css.BrandIconListSection__linkArrow} />
    </a>
  </div>
)

export default BrandIconListSection
